'use client'
import { styled } from '../config'

function ChevronDownSvg(props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M20.0306 10.1998L12.5306 17.6998C12.461 17.7695 12.3783 17.8249 12.2872 17.8626C12.1962 17.9004 12.0986 17.9198 12 17.9198C11.9015 17.9198 11.8039 17.9004 11.7128 17.8626C11.6218 17.8249 11.539 17.7695 11.4694 17.6998L3.96939 10.1998C3.86438 10.0949 3.79285 9.96123 3.76386 9.81567C3.73488 9.67011 3.74973 9.51921 3.80654 9.3821C3.86336 9.24498 3.95958 9.1278 4.08302 9.0454C4.20647 8.963 4.35159 8.91907 4.50001 8.91919H19.5C19.6484 8.91907 19.7936 8.963 19.917 9.0454C20.0404 9.1278 20.1367 9.24498 20.1935 9.3821C20.2503 9.51921 20.2651 9.67011 20.2362 9.81567C20.2072 9.96123 20.1356 10.0949 20.0306 10.1998Z"
        fill="#151923"
      />
    </svg>

    // <svg
    //   width="15"
    //   height="15"
    //   viewBox="0 0 15 15"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   {...props}>
    //   <path
    //     d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z"
    //     fill="currentColor"
    //     fillRule="evenodd"
    //     clipRule="evenodd"></path>
    // </svg>
  )
}

export const ChevronDownTriangle = styled(ChevronDownSvg, {})
